module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app-layout', [_c('v-bloc', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('v-section-header', [_vm._v("\n          Kustannusrivit\n        ")]), _vm._v(" "), _c('v-cost-row-component'), _vm._v(" "), _c('v-nav-footer', {
    attrs: {
      "prevRoute": "inner-basics.index",
      "nextRoute": "inner-files.index",
      "routeParams": {
        projectId: _vm.$store.state.route.params.projectId
      }
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-417139aa"}!./src/app/pages/cost-rows/cost-rows.html
// module id = 472
// module chunks = 1